module.exports = __webpack_public_path__ + "img/thumb-default-video.9aa89ddf.png";